import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CohortFormComponent } from '../cohort-form/cohort-form.component';
import { ToolListService } from '@/shared/services/tool-list.service';

@Component({
  selector: 'app-cohort-info-page',
  templateUrl: './cohort-info-page.component.html',
  styleUrls: ['./cohort-info-page.component.css'],
  standalone: false,
})
export class CohortInfoPageComponent implements OnInit {
  groupVal: string = 'cohort'; //variable to keep change form based on selected targeted group
  studentButton: string = '';

  constructor(
    public dialog: MatDialog,
    public toolListService: ToolListService,
  ) {}

  ngOnInit(): void {
    this.studentButton = this.groupVal;
  }

  //passing child value into parent component and saving to local variable
  getGroup(group: string) {
    this.groupVal = group;
    this.studentButton = this.groupVal; //saving current form group name for button
  }

  // open pop up dialog when in mobile mode if filter is clicked
  openDialog() {
    this.dialog.open(CohortFormComponent);
  }
}
